@if (isVisible) {
  <div class="spinner-position">
    <mat-progress-spinner
      diameter="25"
      [color]="'primary'"
      [mode]="'indeterminate'">
    </mat-progress-spinner>
  </div>
}